"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1QuickFindsGet = void 0;
exports.v1QuickFindsGetSetMock = v1QuickFindsGetSetMock;
exports.v1QuickFindsGet = v1QuickFindsGet;
exports.useQueryV1QuickFindsGet = useQueryV1QuickFindsGet;
exports.useInfiniteQueryV1QuickFindsGet = useInfiniteQueryV1QuickFindsGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1QuickFindsGetSetMock(mock) {
    setMock = mock;
}
async function v1QuickFindsGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/quick-finds`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.limit = params.limit;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1QuickFindsGet = 'wolf-dashboard-service:v1QuickFindsGet:get';
function useQueryV1QuickFindsGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1QuickFindsGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1QuickFindsGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1QuickFindsGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1QuickFindsGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-quick-finds-get.js.map